"use strict";

define('uikit/collections/form',['underscore', 'backbone', './container', '../channel', '../extra/floated', '../extra/size', '../templates', './grid', '../elements/label', '../modules/message'], function (_, Backbone, ContainerView, channel, Floated, Size, Templates, Grid, Label, MessageView) {
  var STATE_VALUES = ['none', 'error', 'loading', 'success', 'warning'];
  var ValidationModel = Backbone.Model.extend({});
  var ValidationMessage = MessageView.extend({
    options: _.extend({}, MessageView.prototype.options, {
      format: 'error',
      header: 'Errors'
    })
  });
  var FormField = ContainerView.extend({
    className: 'field',
    template: Templates.UIKit['form.field'],
    options: {
      disabled: false,
      inline: false,
      floated: '',
      required: false,
      state: '',
      text: '',
      width: '',
      size: ''
    },
    deprecate: {
      width: true
    },
    floatedOptionValues: _.values(Floated),
    stateOptionValues: STATE_VALUES,
    update: {
      disabled: false,
      inline: false,
      required: false,
      width: false,
      size: false
    },
    addField: function addField(options, view) {
      var field = new FormField(options);
      if (view) {
        field.add(view);
      }
      this.add(field);
      return field;
    },
    addGroup: function addGroup(options) {
      var group = new FormFieldGroup(options);
      this.add(group);
      return group;
    },
    updateAttributes: function updateAttributes() {
      this.addClass('disabled', this.getBoolOption('disabled'));
      this.addClass('inline', this.getBoolOption('inline'));
      this.addClass('required', this.getBoolOption('required'));
      this.addClass(this.getStateClass(), this.getBoolOption('state'));
      this.addClass(this.getSizeClass(), this.getBoolOption('size') || this.getBoolOption('width'));
      this.addClass(this.getOption('floated') + ' floated', this.getBoolOption('floated'));
    },
    getStateClass: function getStateClass() {
      switch (this.state) {
        case 'error':
          return this.state;
        default:
          return '';
      }
    },
    getSizeClass: function getSizeClass() {
      var size = Grid.getSizeClass(this.size || this.width) || 'one';
      return size + ' wide';
    },
    parent: function parent() {
      return this.getOption('parent');
    }
  });
  var FormFieldGroup = ContainerView.extend({
    className: 'fields',
    options: {
      inline: false,
      required: false,
      autoSize: true,
      size: null
    },
    updateAttributes: function updateAttributes() {
      this.addClass('inline', this.getBoolOption('inline'));
      this.addClass('required', this.getBoolOption('required'));
      if (this.size) {
        this.addClass(Grid.getSizeClass(this.size));
      } else if (this.autoSize) {
        this.addClass(this.getSizeClass());
      }
    },
    getNumberOfFields: function getNumberOfFields() {
      return this._views.length;
    },
    getSizeClass: function getSizeClass() {
      return Grid.getSizeClass(this.getNumberOfFields());
    },
    addField: function addField(options, contentView) {
      var field = new FormField(options);
      if (contentView) {
        field.add(contentView);
      }
      this.add(field);
      return field;
    },
    addGroup: function addGroup(options) {
      var group = new FormFieldGroup(options);
      this.add(group);
      return group;
    },
    parent: function parent() {
      return this.getOption('parent');
    }
  });
  var Form = ContainerView.extend({
    className: 'ui form',
    options: {
      errorName: 'field',
      errors: null,
      errorText: 'message',
      fluid: false,
      inverted: false,
      segment: false,
      showValidationMessage: false,
      showFieldValidationMessage: true,
      size: '',
      state: ''
    },
    sizeOptionValues: _.values(Size),
    stateOptionValues: STATE_VALUES,
    forceUpdate: {},
    initialize: function initialize() {
      ContainerView.prototype.initialize.apply(this, arguments);
      this._setupValidation();
      this._setupModelListeners();
    },
    onBeforeAdd: function onBeforeAdd(view) {
      this.addedChild(view);
    },
    addedChild: function addedChild(view) {
      if (view instanceof ContainerView) {
        view.each(this.addedChild, this);
        this.listenTo(view, 'add', this.addedChild);
      } else if (view.getOption('name')) {
        this.register(view);
      }
    },
    removeChild: function removeChild(view) {
      this.unregister(view);
    },
    register: function register(view) {
      this[view.getOption('name')] = view;
      return this;
    },
    unregister: function unregister(view) {
      if (view.getOption('name')) {
        this[view.getOption('name')] = null;
      }
      return this;
    },
    addField: FormFieldGroup.prototype.addField,
    addGroup: FormField.prototype.addGroup,
    _setupBindings: function _setupBindings() {
      var ev = this._createBindingsEventObject();
      _.each(this.bindings, function (src, target) {
        var view = this[target];
        this._bindBinding(ev, view, 'value', this.model, src);
      }, this);
    },
    updateAttributes: function updateAttributes() {
      this.addClass('fluid', this.getBoolOption('fluid'));
      this.addClass('inverted', this.getBoolOption('inverted'));
      this.addClass('segment', this.getBoolOption('segment'));
      this.addClass(this.getSizeClass(), this.getBoolOption('size'));
      this.addClass(this.getStateClass(), this.getBoolOption('state'));
    },
    getField: function getField(view) {
      if (view) {
        return view.getOption('parent');
      }
    },
    getFieldByName: function getFieldByName(viewName) {
      var view = this[viewName];
      return this.getField(view);
    },
    getSizeClass: function getSizeClass() {
      switch (this.size) {
        case 'small':
        case 'large':
          return this.size;
        default:
          return '';
      }
    },
    getStateClass: function getStateClass() {
      switch (this.state) {
        case 'error':
        case 'loading':
        case 'success':
        case 'warning':
          return this.state;
        default:
          return '';
      }
    },
    validationLabelOptions: {
      color: 'red',
      prompt: true,
      pointing: true
    },
    isInvalid: function isInvalid() {
      return this.errors && this.errors.length;
    },
    updateValidation: function updateValidation() {
      var binding = this.errorText,
        errors = this.errors,
        errorLabel = null,
        errorField = null;
      this._validationLabels = this._validationLabels || [];
      this.clearValidation();
      if (this.isInvalid()) {
        if (this.getOption('showValidationMessage')) {
          this._updateValidationMsg(errors);
        }
        for (var i = 0, len = errors.length; i < len; i++) {
          errorField = this.getFieldByName(errors.models[i].get(this.errorName));
          if (errorField) {
            errorLabel = new Label(_.extend({
              model: errors.models[i]
            }, this.validationLabelOptions));
            errorLabel.bindings.text = binding;
            this._validationLabels.push(errorLabel);
            errorField.state = 'error';
            errorField.add(errorLabel);
          }
        }
      }
    },
    _updateValidationMsg: function _updateValidationMsg(errors) {
      var filteredErrors = null,
        showFieldValidations = this.getOption('showFieldValidationMessage');
      filteredErrors = errors.filter(function (e) {
        if (showFieldValidations) {
          return true;
        } else {
          return !e.get('field') && !this[e.get('field')];
        }
      }, this);
      if (filteredErrors.length) {
        this.state = 'error';
      }
      if (this._validationMessage) {
        this._validationMessage.collection.reset(filteredErrors);
      }
    },
    _createValidationMsg: function _createValidationMsg() {
      var messageView = new ValidationMessage({
        collection: new Backbone.Collection(),
        childBindings: {
          text: this.errorText
        }
      });
      this.add(messageView, {
        at: 0
      });
      this._validationMessage = messageView;
    },
    clearValidation: function clearValidation() {
      var labels = this._validationLabels || [],
        msg = this._validationMessage,
        label = null,
        field = null;
      this.state = '';
      for (var j = 0, len = labels.length; j < len; j++) {
        label = labels[j];
        field = label.getOption('parent');
        field.state = '';
        field.removeView(label);
      }
      this._validationLabels = [];
    },
    clearErrors: function clearErrors() {
      this.errors.reset([]);
    },
    onChangeModel: function onChangeModel(self, newModel, oldModel) {
      if (oldModel) {
        this.stopListening(oldModel);
      }
      this._setupModelListeners();
    },
    _setupValidation: function _setupValidation() {
      this.errors = new Backbone.Collection([], {
        model: ValidationModel
      });
      this.listenTo(this.errors, 'add remove reset update', _.debounce(this.updateValidation));
      if (this.getOption('showValidationMessage')) {
        this._createValidationMsg();
      }
    },
    _setupModelListeners: function _setupModelListeners() {
      if (!this.model) {
        return;
      }
      this.listenTo(this.model, 'validated', function (model, isValid, validations) {
        var bindings = this.bindings,
          keys = _.keys(this.bindings),
          errors = [];
        errors = _.map(validations, function (v) {
          var field = _.find(keys, function (k) {
            return bindings[k] == v.field;
          }) || v.field;
          return {
            field: field,
            message: v.message
          };
        });
        this.errors.reset(errors);
      });
    },
    _bindUIElements: function _bindUIElements() {}
  });
  Form.FieldGroup = FormFieldGroup;
  Form.Field = FormField;
  Form.ValidationModel = ValidationModel;
  channel.reply('form', function () {
    return Form;
  });
  return Form;
});

